import { Injectable } from '@angular/core';
import { Entitlement, EntitlementBackedRouteActivateGuardService, UserEntitlementService } from '@ddv/entitlements';

@Injectable()
export class CanActivateManageWidgetsGuardService extends EntitlementBackedRouteActivateGuardService {
    constructor(userEntitlementsService: UserEntitlementService) {
        super(userEntitlementsService, Entitlement.WIDGET_CREATE);
    }
}
